import { StorefrontShipmentModule } from '@/shared';

export default StorefrontShipmentModule;
